import { CloseRequestPayload } from "appworks/model/gameplay/requests/close-request-payload";
import { CascadeRequestPayload } from "slotworks/model/gameplay/requests/cascade-request-payload";
import { FreespinRequestPayload } from "slotworks/model/gameplay/requests/freespin-request-payload";
import { GambleRequestPayload } from "slotworks/model/gameplay/requests/gamble-request-payload";
import { RespinRequestPayload } from "slotworks/model/gameplay/requests/respin-request-payload";
import { SpinRequestPayload } from "slotworks/model/gameplay/requests/spin-request-payload";

export interface AdditionalForceData {
    offline?: boolean;
    n?: number[];
    nGenerator?: () => number[];
    [key: string]: any;
}

export interface ForcePayload {
    data: AdditionalForceData;
}

export class ForceRequestPayload extends SpinRequestPayload implements ForcePayload {
    public data: AdditionalForceData;
}

export class ForceFreeSpinRequestPayload extends FreespinRequestPayload implements ForcePayload {
    public data: AdditionalForceData;
}

export class ForceCascadeRequestPayload extends CascadeRequestPayload implements ForcePayload {
    public data: AdditionalForceData;
}

export class ForceRespinRequestPayload extends RespinRequestPayload implements ForcePayload {
    public data: AdditionalForceData;
}

export class ForceGambleRequestPayload extends GambleRequestPayload implements ForcePayload {
    public data: AdditionalForceData;
}

export class ForceCloseRequestPayload extends CloseRequestPayload { }
